'use client';

import { DONATION_ROUTES } from '@/constants';
import { useCustomRouter } from '@/hooks/useCustomRouter';

import { MarketButton } from './MarketButton';

export const DonationButton = () => {
  const { push } = useCustomRouter();

  const handleClick = () => {
    push(
      `${DONATION_ROUTES.HOME.pathname}?utm_source=wello&utm_medium=max_event&utm_campaign=buttn_donation&utm_content=donation_251203`,
    );
  };

  return (
    <MarketButton className="flex-1" dimensions="H56" onClick={handleClick}>
      기부하러가기
    </MarketButton>
  );
};
